import { useEffect, useRef, useState } from "react";

import { useCommunity } from "contexts/community";
import { useAuth } from "@contexts/AuthContext";
import { useScreen } from "Screen/ScreenContext";

import api from "@helpers/api";

export default function useGroup({ community, triggerEdit }) {
    const { community: management, loadCommunities } = useCommunity();
    const { user } = useAuth();
    const { bodyRef } = useScreen();

    const createPostModalRef = useRef();
    const tabsAnchorRef = useRef(null);
    const groupContainerRef = useRef(null);

    const [group, setGroup] = useState(
        community.groups?.length ? community.groups[0].id : null
    );
    const [groupInfo, setGroupInfo] = useState(null);
    const [loadingGroupInfo, setLoadingGroupInfo] = useState(false);
    const [feedRefreshKey, setFeedRefreshKey] = useState(0);

    useEffect(() => {
        if (group) {
            loadGroupInfo();
        } else {
            setGroupInfo(null);
        }
    }, [group]);

    function scrollTabsToTop() {
        const body = bodyRef?.current;
        const anchor = tabsAnchorRef.current;
        if (!body || !anchor) return;
        const bodyRect = body.getBoundingClientRect();
        const anchorRect = anchor.getBoundingClientRect();
        const target = body.scrollTop + (anchorRect.top - bodyRect.top);
        body.scrollTo({ top: target, behavior: "smooth" });
    }

    function handleChangeGroup(newGroupId) {
        setGroup(newGroupId);
        scrollTabsToTop();
    }

    async function loadGroupInfo() {
        if (!group) return;
        setGroupInfo(null);
        setLoadingGroupInfo(true);
        try {
            const { data } = await api.get("community/group/" + group);
            setGroupInfo(data);
        } catch (e) {
            console.log(e);
            setGroupInfo(null);
        }
        setLoadingGroupInfo(false);
    }

    function handleCreatePost() {
        createPostModalRef.current.open({ group, community }, (result) => {
            if (result?.gamification) {
                const { points } = result.gamification;
                if (points.post || points.activity) {
                    window.setSnackbar(
                        `Você ganhou ${points.post + points.activity} pontos`
                    );
                }
            }
            setFeedRefreshKey((k) => k + 1);
            loadCommunities();
        });
    }

    const hasAccess = management?.hasAccessToGroup(community.id, group);
    const currentGroupData = community.groups?.find((g) => g.id === group);
    const groupAvailability = currentGroupData?.availability
        ? { plans: currentGroupData.availability }
        : null;

    return {
        community,
        user,
        group,
        groupInfo,
        loadingGroupInfo,
        hasAccess,
        groupAvailability,
        isAdmin: community.isAdmin(),
        tabsAnchorRef,
        groupContainerRef,
        createPostModalRef,
        feedRefreshKey,
        handleChangeGroup,
        handleCreatePost,
        triggerEdit,
    };
}
